var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-button-totals",class:_vm.menuSideButton ? 'menu-side-button' : '',staticStyle:{"margin-right":"30px"},style:(_vm.color)},[_c('div',{staticClass:"small-button-totals",attrs:{"title":_vm.title}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('i',{class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }